import { Box, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProofingDeliveryMessage } from "./proofing-delivery-message";

interface IProps {
  label?: string;
  tooltipKey?: string;
}

const ProofingNotScheduledDateField = ({
  label,
  tooltipKey = "sales.quote.proofingDatesHiddenTooltip",
}: IProps) => {
  const { t } = useTranslation();
  const dir: "rtl" | "ltr" = t("direction");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 0,
        direction: dir,
        gap: label ? "6px" : 0,
        justifyContent: label ? undefined : "center",
        width: label ? undefined : "100%",
      }}
    >
      {label && (
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: "nowrap",
            padding: 0,
            color: "#667085",
          }}
        >
          {label}
        </Typography>
      )}
      <Tooltip title={t(tooltipKey)} arrow placement="top">
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            cursor: "help",
            alignItems: "center",
          }}
        >
          <ProofingDeliveryMessage variant="inline" showProofingActive={false} />
        </Box>
      </Tooltip>
    </Box>
  );
};

export { ProofingNotScheduledDateField };
